import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-request',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './delete-request.component.html',
  styleUrls: ['./delete-request.component.scss'],
})
export class DeleteRequestComponent {
  @Input() data!: any;
  @Output() delete: EventEmitter<any> = new EventEmitter<any>();

  public removeAlert(): void {
    this.delete.emit(this.data);
  }
}
